export default __webpack_public_path__ + "static/media/patient-diagnoses.99765f9b.less";